export enum CollectLocationDataType {
  reviews = "reviews"
}

export enum EncodeType {
  UTF8 = "UTF-8",
  SHIFT_JIS = "SHIFT_JIS"
}

export interface LocationDataDownloadParams {
  location_id: number;
  data_type: CollectLocationDataType;
  encode?: EncodeType;
}
